const APPLY_URL = "https://pro.form-mailer.jp/fms/e40aa43b232020";

const steps = [
  { icon: "ri-phone-line", title: "お電話・WEBでお申し込み", desc: "お電話またはWebフォームからご予約ください。" },
  { icon: "ri-calendar-check-line", title: "来院日のご確認", desc: "担当スタッフよりご来院日程をご案内します。" },
  { icon: "ri-stethoscope-line", title: "事前面談・口腔内確認", desc: "実際に口腔内を拝見し、患者さまに合った入れ歯をご提案します。" },
  { icon: "ri-hospital-line", title: "入れ歯製作（1日で完成）", desc: "朝9時に来院いただき、夕方には入れ歯が完成します。" },
  { icon: "ri-emotion-happy-line", title: "入れ歯をお渡し", desc: "その日のうちに新しい入れ歯をお持ち帰りいただけます。" },
];

export default function ApplicationSection() {
  return (
    <section id="application" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-700 text-sm font-semibold tracking-widest uppercase mb-3">Application</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            ご予約・お申し込み
          </h2>
          <div className="w-12 h-0.5 bg-amber-500 mx-auto mb-6" />
          <p className="text-gray-600 text-base max-w-md mx-auto">
            Webフォームから24時間いつでもお申し込みいただけます。<br />
            お電話でのご相談も承っております。
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-14">
          {steps.map((step, i) => (
            <div key={step.title} className="flex flex-col items-center text-center">
              <div className="relative mb-4">
                <div className={`w-14 h-14 flex items-center justify-center rounded-full border-2 ${i === 2 ? "bg-amber-50 border-amber-300" : "bg-teal-50 border-teal-200"}`}>
                  <i className={`${step.icon} text-2xl ${i === 2 ? "text-amber-600" : "text-teal-700"}`} />
                </div>
                <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-amber-500 text-white text-xs font-bold rounded-full">
                  {i + 1}
                </span>
              </div>
              <h3 className={`text-sm font-semibold mb-1 ${i === 2 ? "text-amber-700" : "text-gray-800"}`}>{step.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Notice */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg px-6 py-4 text-sm text-amber-800 flex items-start gap-3 mb-10">
          <i className="ri-information-line text-amber-500 text-base mt-0.5 flex-shrink-0" />
          <p>
            入れ歯の製作前に<strong>事前面談（口腔内確認）</strong>を1回行います。患者さまの口腔状態や要望を丁寧に確認した上で、最適な入れ歯をご提案いたします。
          </p>
        </div>

        {/* CTA Block */}
        <div className="bg-teal-700 rounded-xl p-10 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-teal-200 text-sm font-semibold mb-2">24時間受付中</p>
            <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              Webフォームから今すぐご予約
            </h3>
            <p className="text-white/70 text-sm">
              お申し込みフォームよりご予約いただけます。<br />
              スタッフよりご連絡いたします。
            </p>
          </div>
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer flex-shrink-0 bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg px-10 py-4 rounded-md transition-colors"
          >
            申し込みフォームへ <i className="ri-external-link-line ml-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
